export enum FB_Template {
  Global_Planning = 1,
  Regional_Planning = 2,
  Retail_Direct = 3,
  Retail_InDirect = 4,
  Split_Percentage = 5,
  Multi_ItemView = 6,
  Dip_Top_Down_Planning = 7,
  PP_Planner = 8,
  REPL_PLANNER = 9,
  Retail_Planner = 10,
  Customer_Order_Planner = 11
}
export enum SPLIT_TYPE {
  ITEM_VIEW = 0,
  CHANNEL_VIEW = 1
}
export enum SPLIT_GROUP_TYPE {
  NONE = 0,
  SPLIT_GDP = 1,
  SPLIT_RDP = 2,
  SPLIT_ACCESSORIES_GDP = 3,
  SPLIT_ACCESSORIES_RDP = 4
}
